<div class="logged-out">
  <mat-card appearance="outlined" class="logged-out__content" data-test-id="logged-out-card">
    <mat-card-header>
      <mat-card-title>{{ 'Bis bald' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'Sie haben sich erfolgreich ausgeloggt' | translate }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-actions class="center-actions">
      <button mat-flat-button color="primary" [routerLink]="[loginUrl]" class="logged-out__button">
        {{ 'Einloggen' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</div>
